import { getSettingValueWithoutAssignment } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/getSetting";
import { FE_ENABLE_PDP_NAVIGATION_STAGING } from "@faire/retailer-settings/FE_ENABLE_PDP_NAVIGATION_STAGING";

export const getSettingEnableStagingPDPLink = (): boolean =>
  getSettingValueWithoutAssignment(FE_ENABLE_PDP_NAVIGATION_STAGING, false);
